import { Component, Input } from '@angular/core';
import { NoteService } from '../note.service';

const DOTTED_FRETS = [3, 5, 7, 9, 12, 15, 17, 19, 21];

@Component({
  selector: 'app-string',
  templateUrl: './string.component.html',
  styleUrls: ['./string.component.scss'],
})
export class StringComponent {
  @Input() open: string;
  @Input() totalFrets: number = 12;
  // @Input() notes: string[] = this.noteService.ALL_NOTES;

  @Input() set notes(visible: string[]) {
    this.frets = this.noteService
      .getSequentialNotes(this.open, this.totalFrets)
      .map((n, i) => {
        const isVisible = visible.find((v) => v === n);

        return {
          fretNumber: i + 1,
          note: n,
          highlighted: isVisible,
          displayName: n.includes('/') ? n.split(' / ')[0] : n,
        };
      });
  }

  // Input for prefer flats?

  // @Input() shownNotes: string[] = ['G']

  frets: { fretNumber: number; note: string }[];

  constructor(private noteService: NoteService) {}

  // ngOnInit(): void {
  //   this.frets = this.noteService
  //     .getSequentialNotes(this.open, this.totalFrets)
  //     .map((n, i) => {
  //       return {
  //         fretNumber: i + 1,
  //         note: n,
  //         highlighted: this.notes.includes(n),
  //         displayName: n.includes('/') ? n.split(' / ')[0] : n,
  //       };
  //     });
  // }

  isDotted(fretNumber: number) {
    const isDotted = DOTTED_FRETS.includes(fretNumber);
    return isDotted;
  }
}
